/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CompetitionQueryResult from './CompetitionQueryResult';

/**
 * The CompetitionOutputCompetition model module.
 * @module model/CompetitionOutputCompetition
 * @version 1.0
 */
class CompetitionOutputCompetition {
    /**
     * Constructs a new <code>CompetitionOutputCompetition</code>.
     * @alias module:model/CompetitionOutputCompetition
     */
    constructor() { 
        
        CompetitionOutputCompetition.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CompetitionOutputCompetition</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CompetitionOutputCompetition} obj Optional instance to populate.
     * @return {module:model/CompetitionOutputCompetition} The populated <code>CompetitionOutputCompetition</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompetitionOutputCompetition();

            if (data.hasOwnProperty('competition')) {
                obj['competition'] = CompetitionQueryResult.constructFromObject(data['competition']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/CompetitionQueryResult} competition
 */
CompetitionOutputCompetition.prototype['competition'] = undefined;






export default CompetitionOutputCompetition;

